module.exports = __webpack_public_path__ + "img/pole-blue.33ccf1e1.jpg";